export const messageKeys = {
  all: ['messages'] as const,
  // Prefix key: invalidating it hits every filter variant.
  conversationsRoot: () => [...messageKeys.all, 'conversations'] as const,
  conversations: (filter: 'all' | 'unread') =>
    [...messageKeys.conversationsRoot(), filter] as const,
  unreadCount: () => [...messageKeys.all, 'unread-count'] as const,
  jobMessages: (jobId: string) => [...messageKeys.all, 'job', jobId] as const,
};
